var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTab2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 42.75C3.2625 42.75 2.2035 42.3098 1.323 41.4293C0.4425 40.5488 0.0015 39.489 0 38.25V29.25H15.75V33.75H29.25V29.25H45V38.25C45 39.4875 44.5598 40.5473 43.6793 41.4293C42.7988 42.3113 41.739 42.7515 40.5 42.75H4.5ZM20.25 29.25V24.75H24.75V29.25H20.25ZM0 24.75V13.5C0 12.2625 0.441 11.2035 1.323 10.323C2.205 9.4425 3.264 9.0015 4.5 9H13.5V4.5C13.5 3.2625 13.941 2.2035 14.823 1.323C15.705 0.4425 16.764 0.0015 18 0H27C28.2375 0 29.2973 0.441 30.1793 1.323C31.0613 2.205 31.5015 3.264 31.5 4.5V9H40.5C41.7375 9 42.7973 9.441 43.6793 10.323C44.5613 11.205 45.0015 12.264 45 13.5V24.75H29.25V20.25H15.75V24.75H0ZM18 9H27V4.5H18V9Z",
    fill: "url(#paint0_linear_444_5095)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_5095",
    x1: 44,
    y1: 2,
    x2: 0.500003,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3AACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab2);
export default __webpack_public_path__ + "static/media/tab-2.59ddabd2c23753c7619904cf9a78041f.svg";
export { ForwardRef as ReactComponent };